/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * GetBillingDetailsBase
 * auto generated base class for the model GetBillingDetailsModel.
 */
export const GetBillingDetailsModelBase = ModelBase.named('GetBillingDetails')
  .props({
    __typename: types.optional(types.literal('GetBillingDetails'), 'GetBillingDetails'),
    last4: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class GetBillingDetailsModelSelector extends QueryBuilder {
  get last4() {
    return this.__attr('last4')
  }
}
export function selectFromGetBillingDetails() {
  return new GetBillingDetailsModelSelector()
}

export const getBillingDetailsModelPrimitives = selectFromGetBillingDetails().last4
